// extracted by mini-css-extract-plugin
export default {"body":"method-chooser_body__ZT+ST","method-stack":"method-chooser_method-stack__vhKbB","email-summary":"method-chooser_email-summary__5i9ql"};